export const slbEdgeSolutionsPdp = {
  edgeSolutionsForm: {
    version: 'Gateway version',
    quantity: 'Quantity',
    installationService: 'Gateway installation service',
    dataExplorer: '“Data Explorer” application subscription',
    quantityOnePerRodPump: 'Quantity (one per rod pump)',
    included: 'Included',
    doNotInclud: 'Do not include',
    includedWithPrice: 'Included <span>{{ price }}</span> / unit',
    includedWithPriceDataExplorer: 'Included <span>{{ price }}</span> / unit / year',
  },
  edgeSolutionsCard: {
    quantity: 'Quantity',
    hardwarePrice: 'Hardware price',
    price: "Price",
    installationService: 'Gateway installation service',
    dataExplorer: 'Data Explorer application subscription',
    agoraGateway: 'Agora Gateway',
    priceUnit: '{{ price }} / unit',
    priceMonth: '{{ price }} / month',
    priceUnitYear: '{{ price }} / unit / year'
  },
  edgeSolutionsPage: {
    description: 'Description',
    features: 'Features',
    additionalMaterials: 'Additional materials',
    edgeSolutions: 'Edge Solutions',
    applicationsWorks: 'This application only works with',
    agoraGateway: 'Agora Gateway v.403 "Advanced" or',
    v403: ' v.403 "Production" device.',
    oneGateway: 'One Gateway supports up to 15 instances of the application',
    withGatewayInstallationAndDataExplorer: ' with installation services and Data Explorer ',
    withGatewayInstallation: ' with installation services ',
    withDataExplorer: ' with Data Explorer ',
    empty: ''
  }
};
